/**
 * User: herbert
 * Date: 09.03.16
 * Time: 19:19
 */

// TODO horizontal scrolling
// TODO parameters for horizontal and/or vertical scrolling

/* eslint react/sort-comp: 0 */

 import React from 'react';

import 'nnraf/nnraf'; // make sure, requestAnimationFrame and cancelAnimationFrame are available

function positionFormula(pos, planSize, windowSize) {
	return ( - pos * ( planSize / windowSize - 1 ) );
}

function easeInQuad(currentIteration, startValue, changeInValue, totalIterations) {
	return changeInValue * (currentIteration /= totalIterations) * currentIteration + startValue;
}

export default React.createClass({
	propTypes: {
		children: React.PropTypes.node, //FIXME set required
		hideCallback: React.PropTypes.func //FIXME set required
	},
	getDefaultProps: function() {
		return {
			//initialPos: 0,
			children: null,
			hideCallback: null
		};
	},
	getInitialState: function() {
		return {
		};
	},
	updatePosition: function(x, y) {
		this.old_x = x;
		this.old_y = y;
		const plan = this.refs.scrollDiv ? this.refs.scrollDiv.getBoundingClientRect() : null;
		if(!plan)
			return;
		let left = positionFormula(x, plan.width, window.innerWidth);
		let	top = positionFormula(y, plan.height, window.innerHeight);
		left = left > 0 ? ( window.innerWidth - plan.width ) / 2 : left; // FIXME Wertbegrenzung
		top = top > 0 ? ( window.innerHeight - plan.height ) / 2 : top; // FIXME Wertbegrenzung

		// FIXME setStyle
		//this.plan.style.left = left+"px";
		//this.plan.style.top = top+"px";
		this.refs.scrollDiv.setAttribute('style', 'position:absolute;width:100%;height:auto;top:' + top + 'px;');
	},
	// läuft ständig im hintergrund solange es sichtbar ist. mouse_move ändert this.new_
	animate: function() {
		const x = Math.floor(easeInQuad(1, this.old_x, this.new_x - this.old_x, 3) + 0.5);
		const y = Math.floor(easeInQuad(1, this.old_y, this.new_y - this.old_y, 3) + 0.5);
		this.updatePosition(x, y);
		this.iteration ++; // wird gar nicht genutzt
		this.raf = requestAnimationFrame(this.animate);
	},

	clearAnimation: function() {
		cancelAnimationFrame(this.raf);
	},

	launchAnimation: function(x, y) {
		//if(Global.is_touch) { // wenn kein mouseMove keine updates -> reguläres Scrollen? Startet zentriert
		//	var left = (this.plan.clientWidth - global.win_size.width) / 2;
		//	var top = (this.plan.clientHeight - global.win_size.height) / 2;
		//	this.plan.parentNode.scrollLeft = left;
		//	this.plan.parentNode.scrollTop = top;
		//	return;
		//}
		this.updatePosition(x, y);
		this.animate();
	},

	componentDidMount: function() {
		document.addEventListener('mousedown', this.onMouseDown);
		document.addEventListener('mousemove', this.onMouseMove);
		document.addEventListener('mouseup', this.onMouseUp);
		document.addEventListener('mouseleave', this.onMouseLeave);
		window.setTimeout(() => document.addEventListener('click', this.onClick), 100); // ignore click to parent's zoom icon

		this.old_x = this.old_x || 0;
		this.old_x = this.old_y || 0;
		//this.$el
		//		.css("opacity", 0)
		//		.animate({"opacity": 1}, global.animation_duration);
		this.new_x = this.old_x;
		this.new_y = this.old_x;
		this.launchAnimation(this.old_x, this.old_x);
	},
	componentWillUnmount: function() {
		document.removeEventListener('click', this.onClick);
		document.removeEventListener('mousedown', this.onMouseDown);
		document.removeEventListener('mousemove', this.onMouseMove);
		document.removeEventListener('mouseup', this.onMouseUp);
		this.clearAnimation();
	},
	onClick: function() {
		if(this.props.hideCallback)
			this.props.hideCallback();
	},
	onMouseDown: function(/**MouseEvent*/ e) {
		if(e.which === 1) {
			this.state.downY = e.clientY;
		} else {
			this.state.downY = null;
		}
	},
	onMouseMove: function(/**MouseEvent*/ e) {
		//
		//if(e.which === 1 && this.state.downY !== null && this.scrollDiv !== null) {
			this.new_x = e.clientX;
			this.new_y = e.clientY;
			this.iteration = 0;
		//}

		//
		//
		////console.log('mm', e.which, this.state.downY, this.scrollDiv, this.state.pos)
		//if(e.which === 1 && this.state.downY !== null && this.scrollDiv !== null) {
		//	const delta = e.clientY - this.state.downY;
		//	this.state.downY = e.clientY;
		//	this.state.pos += delta;
		//
		//	const clientRect = this.scrollDiv !== null ? this.scrollDiv.getBoundingClientRect() : null;
		//
		//	if(this.state.pos > 0 )
		//		this.state.pos = 0;
		//	else if(clientRect !== null && this.state.pos < -(clientRect.height - window.innerHeight)) {
		//		this.state.pos = -(clientRect.height - window.innerHeight);
		//	}
		//
		//
		//	// eventuell ohne render direkt die ref des divs verändern
		//	if(this.scrollDiv) this.scrollDiv.setAttribute('style', 'position:absolute;width:100%;height:auto;top:' + this.state.pos + 'px;');
		//} else {
		//	this.state.downY = null;
		//}
	},
	onMouseUp: function(/**MouseEvent*/ e) {
		//this.state.downY = null;
	},
	onMouseLeave: function(/**MouseEvent */ e) {
		//this.state.downY = null;
	},
	render: function() {
		// style={{position: 'fixed', bottom: 0, height: '100%', width: '100%', zIndex: 600, backgroundColor: 'green'}} >
		return (
				<div className={this.props.hideCallback ? 'nn-fullscreen nn-fullscreen__close' : 'nn-fullscreen'} >
					<div ref="scrollDiv" style={{position: 'absolute', width: '100%', height: 'auto'}}>
						{this.props.children}
					</div>
				</div>);
	}
});
